document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.tcm-section');

  sections.forEach(section => {
    const menuItems = section.querySelectorAll('.tcm-menu-item');

    // Apply effects for TCM sections
    function applyEffects(target) {
      if (target.classList.contains('tcm-section')) {
        const backgroundImage = target.dataset.backgroundImage || '';
        section.style.backgroundImage = backgroundImage ? `url(${backgroundImage})` : 'none';

        // Clear previous TCM effects
        section.classList.remove('tcm-blur', 'tcm-sepia', 'tcm-contrast');

        // Apply TCM effects
        if (target.dataset.tcmBlur === 'true') {
          section.classList.add('tcm-blur');
          section.style.setProperty('--tcm-blur-amount', `${target.dataset.tcmBlurAmount}px`);
        }
        if (target.dataset.tcmSepia === 'true') {
          section.classList.add('tcm-sepia');
          section.style.setProperty('--tcm-sepia-amount', target.dataset.tcmSepiaAmount);
        }
        if (target.dataset.tcmContrast === 'true') {
          section.classList.add('tcm-contrast');
          section.style.setProperty('--tcm-contrast-amount', target.dataset.tcmContrastAmount);
        }
      }
    }

    // Initial application
    applyEffects(section);

    // Menu item hover for TCM sections
    if (menuItems.length > 0) {
      menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          section.dataset.backgroundImage = item.dataset.backgroundImage;
          section.dataset.tcmBlur = item.dataset.tcmBlur;
          section.dataset.tcmBlurAmount = item.dataset.tcmBlurAmount;
          section.dataset.tcmSepia = item.dataset.tcmSepia;
          section.dataset.tcmSepiaAmount = item.dataset.tcmSepiaAmount;
          section.dataset.tcmContrast = item.dataset.tcmContrast;
          section.dataset.tcmContrastAmount = item.dataset.tcmContrastAmount;
          applyEffects(section);
        });

        item.addEventListener('mouseleave', () => {
          section.dataset.backgroundImage = '';
          section.dataset.tcmBlur = 'false';
          section.dataset.tcmSepia = 'false';
          section.dataset.tcmContrast = 'false';
          applyEffects(section);
        });
      });
    }

    // Observe changes for real-time updates (compatible with theme-editor.js)
    const observer = new MutationObserver(() => applyEffects(section));
    observer.observe(section, { attributes: true });
  });
});